import { gql } from 'urql';

const GetAutomaticSavings = gql`
  query GetAutomaticSavingsInfo {
    user {
      id
      customerInfo {
        __typename
        id
        myp {
          id
          percentage
          __typename
        }
        automaticSavings {
          __typename
          ... on AutomaticSavingsFeaturesEnabled {
            syp {
              percentage
            }
            syc {
              id
              enabled
            }
          }
        }
      }
    }
  }
`;

export default GetAutomaticSavings;
